import { Component } from 'solid-js';
import { useLanguage } from '../i18n/LanguageContext';
import { useNavigation } from '../contexts/NavigationContext';
import LanguageSelector from './LanguageSelector';

const Header: Component = () => {
  const { t, language } = useLanguage();
  const { currentPage, navigateToHome, navigateToBlog, navigateToCV } = useNavigation();

  const handleHomeClick = (e: MouseEvent) => {
    e.preventDefault();
    navigateToHome();
  };

  const handleBlogClick = (e: MouseEvent) => {
    e.preventDefault();
    navigateToBlog();
  };

  const handleCVClick = (e: MouseEvent) => {
    e.preventDefault();
    navigateToCV();
  };

  return (
    <header class="header">
      <nav class="nav">
        <a href="#" onClick={handleHomeClick} class="nav-brand">
          <img src="/logo.png" alt="Logo" class="nav-logo" />
        </a>
        <ul class="nav-links">
          <li><a href="#" onClick={handleHomeClick} classList={{ active: currentPage() === 'home' }}>Portfolio</a></li>
          <li><a href="#" onClick={handleBlogClick} classList={{ active: currentPage() === 'blog' || currentPage() === 'blog-article' }}>{t('nav.blog')}</a></li>
          <li><a href="#" onClick={handleCVClick} classList={{ active: currentPage() === 'cv' }}>CV</a></li>
        </ul>
        <LanguageSelector />
      </nav>
    </header>
  );
};

export default Header;
